import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import styles from "@/styles/jss/nextjs-material-kit-pro/components/buttonStyle.js";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
import { jsx as _jsx } from "react/jsx-runtime";
const useStyles = makeStyles(styles);
const RegularButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    color,
    round,
    children,
    fullWidth,
    disabled,
    simple,
    size,
    block,
    link,
    justIcon,
    fileButton,
    className,
    variant,
    onClick,
    href,
    style,
    sx,
    ...rest
  } = props;
  const classes = useStyles();
  const btnClasses = classNames({
    [classes.button]: true,
    [classes[size]]: size,
    [classes[color]]: color,
    [classes.round]: round,
    [classes.fullWidth]: fullWidth,
    [classes.disabled]: disabled,
    [classes.simple]: simple,
    [classes.block]: block,
    [classes.link]: link,
    [classes.justIcon]: justIcon,
    [classes.fileButton]: fileButton,
    [className]: className
  });
  const buttonProps = {
    ...rest,
    ref,
    className: btnClasses,
    disabled,
    onClick,
    href,
    style,
    sx,
    variant: variant || (simple ? "text" : "contained")
  };
  return /*#__PURE__*/_jsx(Button, {
    ...buttonProps,
    children: children
  });
});
RegularButton.displayName = "RegularButton";
export default RegularButton;